<template>
  <validation-provider v-slot="validationContext" :vid="vid" :name="labelText" :rules="rules" :mode="providerMode" :custom-messages="customMessages" slim>
    <base-vue-multi-select
      :value="value"
      :validation-context="validationContext"
      v-bind="$props"
      :clean-option="cleanOption"
      @input="$emit('input', $event)"
      @select="$emit('select', $event)"
      @remove="$emit('remove', $event)"
      @search-change="$emit('searchChange', $event)"
      @tag="$emit('tag', $event)"
      @open="$emit('open', $event)"
      @close="$emit('close', $event)"
    />
  </validation-provider>
</template>

<script>
import BaseVueMultiSelect from "./BaseVueMultiSelect.vue";

export default {
  name: "MultiSelectWrapper",
  components: {
    BaseVueMultiSelect,
  },
  props: {
    // Validation related props
    vid: {
      type: String,
      default: null,
    },
    labelText: {
      type: String,
      default: null,
    },
    rules: {
      type: [String, Object],
      default: null,
    },
    customMessages: {
      type: Object,
      default: () => ({}),
    },
    providerMode: {
      type: String,
      default: "eager",
    },
    // All other props from BaseVueMultiSelect
    value: {
      type: [Array, String, Number, Object],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Seçiniz",
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    trackBy: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    clearOnSelect: {
      type: Boolean,
      default: false,
    },
    hideSelected: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    resetAfter: {
      type: Boolean,
      default: false,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    tagPlaceholder: {
      type: String,
      default: "Etiket oluşturmak için enter tuşuna basın",
    },
    tagPosition: {
      type: String,
      default: "top",
    },
    max: {
      type: Number,
      default: null,
    },
    optionsLimit: {
      type: Number,
      default: 1000,
    },
    groupLabel: {
      type: String,
      default: null,
    },
    groupSelect: {
      type: Boolean,
      default: false,
    },
    blockKeys: {
      type: Array,
      default: () => [],
    },
    internalSearch: {
      type: Boolean,
      default: false,
    },
    preserveSearch: {
      type: Boolean,
      default: false,
    },
    preselectFirst: {
      type: Boolean,
      default: false,
    },
    preventAutofocus: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 99999,
    },
    limitText: {
      type: [Function, String],
      default: (count) => `${count} seçildi`,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    openDirection: {
      type: String,
      default: "",
    },
    maxHeight: {
      type: Number,
      default: 264,
    },
    optionHeight: {
      type: Number,
      default: 55,
    },
    selectClass: {
      type: [String, Array],
      default: null,
    },
    dataWidth: {
      type: String,
      default: null,
    },
    textField: {
      type: String,
      default: "name",
    },
    valueField: {
      type: String,
      default: "id",
    },
    showNoOptions: {
      type: Boolean,
      default: true,
    },
    showNoResults: {
      type: Boolean,
      default: true,
    },
    formGroupClass: {
      type: [String, Array],
      default: null,
    },
    requiredStar: {
      type: Boolean,
      default: false,
    },
    labelIcon: {
      type: Boolean,
      default: false,
    },
    // Small info icon next to the label; shows the given text as a tooltip on hover.
    // A lighter, tooltip-based alternative to labelIcon (which opens a modal).
    labelTooltip: {
      type: String,
      default: null,
    },
    labelClass: {
      type: [String, Array],
      default: null,
    },
    labelInfoModalId: {
      type: String,
      default: null,
    },
    cleanOption: {
      type: Boolean,
      default: true,
    },
    enableSort: {
      type: Boolean,
      default: true,
    },
    noOptionsText: {
      type: String,
      default: "SEÇENEK BULUNAMADI",
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    appendToBodyPlacement: {
      type: String,
      default: "bottom-start",
    },
    sortBy: {
      type: String,
      default: "",
    },
    isSortDesc: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
